import React from 'react'
import "./loader.css";
function Loader(props) {     
  if(props.show){
    return props.loader?  <div className='loader-wrap'><span className={`loader-${props.loader}`}> </span></div> : <div className='loader-wrap'><span className="loader"> </span></div>
  }    
}

export default Loader